import * as React from "react";
import './../../App.css';
import './../wallet/WalletPage.css'
import './CardPage.css'
import AuthCheck from "../../components/auth/AuthCheck";
import {useEffect} from "react";
import {Business, CardTransaction, CurrentUser, UserCard, UserType} from "../../types/Types";
import {collection, getDocs, limit, query, where, orderBy, onSnapshot} from "@firebase/firestore";
import {db} from "../../firebase/FirebaseProvider";
import {useState} from "react";
import CardAddPoints from "./configure/CardAddPoints";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCog, faLocationDot} from "@fortawesome/free-solid-svg-icons";
import {useNavigate, useParams} from "react-router";
import TransactionList from "../../components/transaction/TransactionList";
import OfferList from "../../components/offer/OfferList";
import LoadingWheel from "../../components/loading/LoadingWheel";
import PointsCardV2 from "../../components/card/PointsCardV2";

interface Props {
  currentUser: CurrentUser,
  businessMap: Map<string, Business>,
}

function CardPage(props: Props) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(true);
  const [user, setUser] = useState<CurrentUser>();
  const [business, setBusiness] = useState<Business>();
  const [pointsCard, setPointsCard] = useState<UserCard>();
  const [transactionsMap] = useState<Map<string, CardTransaction>>(new Map<string, CardTransaction>());
  const [transactions, setTransactions] = useState<Array<CardTransaction>>([]);

  const { id: cardId } = useParams();

  useEffect(() => {
    onSnapshot(query(
        collection(db, 'cards'),
        where("id", "==", cardId),
        limit(1),
    ), (snapshot) => {
      snapshot.docChanges().forEach(card => {
        if (card.type === 'added' || card.type === 'modified') {
          const pointsCard = card.doc.data() as UserCard;
          setPointsCard(pointsCard);
          getBusinessAndUser(pointsCard);
        }
      });
    });
    setLoading(false);
  }, []);

  useEffect(() => {
    onSnapshot(query(
        collection(db, 'transactions'),
        where("card", "==", cardId),
        orderBy("createdAt", "desc"),
        limit(1000),
    ), (snapshot) => {
      snapshot.docChanges().forEach(transaction => {
        if (transaction.type === 'added' || transaction.type === 'modified') {
          const cardTransaction = transaction.doc.data() as CardTransaction;
          transactionsMap.set(cardTransaction.id, cardTransaction);
          setTransactions(Array.from(transactionsMap.values()).sort((a, b) => b.createdAt.toMillis() - a.createdAt.toMillis()));
        } else if (transaction.type === 'removed') {
          transactionsMap.delete(transaction.doc.data().id)
        }
      });
    });
  }, []);

  const getBusinessAndUser = (pointsCard: UserCard) => {
    setBusiness(props.businessMap.get(pointsCard.business));
    const retrievedUser = query(
        collection(db, 'users'),
        where("id", "==", pointsCard!.user),
        limit(1),
    );
    getDocs(retrievedUser).then((data) => {
      data.forEach((doc) => {
        setUser(doc.data() as CurrentUser);
      });
    })
  };

  if(pointsCard && props.currentUser.business && props.currentUser.business !== pointsCard.business) {
    navigate("/");
  }

  if(pointsCard && props.currentUser.userType === UserType.CUSTOMER && props.currentUser.id !== pointsCard.user) {
    navigate("/");
  }

  return (
      <>
        <AuthCheck />
        <div className={"centre-align"}>
          <div className={"d-inline-block me-1 mt-1 mb-1"}>
            {(pointsCard && user) && <PointsCardV2 user={user} pointsCard={pointsCard} business={props.businessMap.get(pointsCard.business)} />}
          </div>
          {(!pointsCard || !user) && <div className={"loading"}><LoadingWheel /></div>}
        </div>

        {pointsCard && <CardAddPoints
            currentUser={props.currentUser}
            business={props.businessMap.get(pointsCard.business)}
            card={pointsCard}
        />}

        <div className={"row"}>
          {(business && props.currentUser.userType === UserType.CUSTOMER) && <div className={"col mt-3"}>
              <div className={"primary-button mb-0"} onClick={() => navigate(`/location/${business.locations[0]}`)}>
                  <b>View Location</b>
                  <FontAwesomeIcon className={"ms-2"} icon={faLocationDot}/>
              </div>
          </div>}

          {(business && props.currentUser.userType === UserType.CUSTOMER) && <div className={"col mt-3"}>
              <div className={"primary-button mb-0"} onClick={() => {}}>
                  <b>Card Settings</b>
                  <FontAwesomeIcon className={"ms-2"} icon={faCog}/>
              </div>
          </div>}
        </div>

        {pointsCard && <OfferList
            currentUser={props.currentUser}
            businessMap={props.businessMap}
            business={pointsCard.business}
            location={undefined}
            displayTitle={"Available Offers"}
            defaultDisplayList={props.currentUser.userType === UserType.CUSTOMER}
            pointsCard={pointsCard}
        />}

        <TransactionList transactions={transactions} businessMap={props.businessMap} defaultDisplayList={false} />
      </>
  );
}

export default CardPage;